import http from './http-common';

class PISalesAgentService {
  getList() {
    return http.get(`/PI-sales-agent/list`);
  }
  PIForlist(data) {
    const queryParams = new URLSearchParams(data).toString();
    return http.get(`/PI-sales-agent/PIForlist?${queryParams}`);
  }
  getSupplierForDD() {
    return http.get(`/PI-sales-agent/supplier/dropdown`);
  }
  getCustomerForDD(id = 0) {
    return http.get(`/PI-sales-agent/customer/dropdown/${id}`);
  }
  getSaleAgentForDD() {
    return http.get(`/PI-sales-agent/employee/dropdown`);
  }
  getCountryCityPortForDD() {
    return http.get(`/PI-sales-agent/countryCityPort/dropdown`);
  }
  getShipmentTypeForDD() {
    return http.get(`/PI-sales-agent/shipmentType/dropdown`);
  }
  getCurrencyForDD() {
    return http.get(`/PI-sales-agent/currency/dropdown`);
  }
  getAllEmployee() {
    return http.get(`/PI-sales-agent/employee`);
  }
  getPurchaseSourceForDD() {
    return http.get(`/PI-sales-agent/purchaseSource/dropdown`);
  }
  getTradeBoardLetterStatusForDD() {
    return http.get(`/PI-sales-agent/tradeBoardLetterStatus/dropdown`);
  }
  getPaymentTypeForDD() {
    return http.get(`/PI-sales-agent/paymentType/dropdown`);
  }
  getSalesAgentStatusForDD() {
    return http.get(`/PI-sales-agent/salesAgentStatus/dropdown`);
  }
  addProformaInvoice(data) {
    return http.post(`/PI-sales-agent/insert/proformaInvoice`, data);
  }
  addProformaInvoiceGrid(data) {
    return http.post(`/PI-sales-agent/insert/proformaInvoiceGrid`, data);
  }
  getPaymentDetail(id) {
    return http.get(`/PI-sales-agent/getPaymentDetail/${id}`);
  }
  getEmployeeName(id) {
    return http.get(`/PI-sales-agent/getEmployeeName/${id}`);
  }
  getCommissionAmountPerUnit(currencyID, supplierID, employeeID) {
    return http.get(`/PI-sales-agent/getCommissionAmountPerUnit/${currencyID}/${supplierID}/${employeeID}`);
  }
  getSecondaryCommissionPercentOnAdjustment(currencyID, supplierID, employeeID) {
    return http.get(`/PI-sales-agent/getSecondaryCommissionPercentOnAdjustment/${currencyID}/${supplierID}/${employeeID}`);
  }
  getPrimaryCommissionPercentOnAdjustment(supplierID, employeeID) {
    return http.get(`/PI-sales-agent/getPrimaryCommissionPercentOnAdjustment/${supplierID}/${employeeID}`);
  }
  updatePI(id, data) {
    return http.put(`/PI-sales-agent/editPaymentDetail/${id}`, data);
  }
  PIEdit(data) {
    return http.put(`/PI-sales-agent/editPI`, data);
  }
  getInitialPaymentPercent(customerID, currencyID) {
    return http.get(`/PI-sales-agent/InitialPaymentPercent/${customerID}/${currencyID}`);
  }
  updatingSp(id, value) {
    return http.get(`/PI-sales-agent/update/sp/${id}/${value}`);
  }
  getToEmails() {
    return http.get(`/PI-sales-agent/toEmails/list`);
  }
  deletePi(piid) {
    return http.delete(`/PI-sales-agent/delete/pi/${piid}`);
  }
  getPIBalance(piid) {
    return http.get(`/PI-sales-agent/PIBalance/${piid}`);
  }
  uploadPIPdf(data) {
    return http.post(`/PI-sales-agent/Upload/Pdf`, data);
  }
  getPIPDFFiles(id) {
    return http.get(`/PI-sales-agent/PIPDFFiles/${id}`);
  }
  deleteAllPdfByPIID(id, year) {
    return http.put(`/PI-sales-agent/deleteAllPdfByPIID/${id}/${year}`);
  }
  deletePDFFilebyPIPDFID(data) {
    return http.put(`/PI-sales-agent/deletePDFFilebyPIPDFID`, data);
  }
}
export default new PISalesAgentService();
